// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/pagecontainer/modules/chats/components/chatitem/index.scss
// module id = 2370
// module chunks = 13